import axios from "axios";

export const getJobManagements = (country_id, callback) => {
  var promise = axios({
    method: "get",
    url: `/api/job_divisions/${country_id}/job_managements`
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
